import { Schema } from 'normalizr';
import { baseSchema } from '../../../types/schema';
import { keys } from './keys';
import { unitSchema } from '../../Synchronize/Units/schema';
import { unitSystemSchema } from '../../Synchronize/UnitSystems/schema';

/**
 * Piping Materials Entity Schema
 *
 * Normalizr schema for Piping Materials entities.
 * Defines relationships to Unit and UnitSystem entities for density measurements.
 */
export const materialSchema: Schema = baseSchema(keys.state, {
  densityUnit: { schema: unitSchema, isId: true },
  unitSystem: { schema: unitSystemSchema, isId: true },
});

